var _module_exports ="<div class=\"row\">\n    <!-- Side bar -->\n    <div ui-view=\"sidebar\">\n    </div>\n\n    <!-- Main Content -->\n    <div ui-view=\"mainContent\">\n    </div>\n</div>";;
var path = '/app/Main/riskSelfAssessment/assess/assess.tpl.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;